<template>
  <div 
    v-if="userBillingList.length"
    class="sm-plans__charges"
  >
    <div class="sm-plans__controls">
      <div class="sm-plans__controls-left">
        <h4>Charges</h4>
      </div>
    </div>

    <div class="sm-plans__charges-table">
      <div class="sm-mobile-table sm-plans__charges-table-mobile">
        <div class="sm-mobile-table-item header">
          <div class="sm-mobile-table-item-row">
            <div class="sm-mobile-table-item-row-th control-arrow"></div>
            <div class="sm-mobile-table-item-row-th description">Description</div>
            <div
              v-if="viewPort == 'large'" 
              class="sm-mobile-table-item-row-th date"
            >Date</div>
            <div
              v-if="viewPort == 'large'" 
              class="sm-mobile-table-item-row-th amount"
            >Amount</div>
            <div
              v-if="viewPort == 'large'" 
              class="sm-mobile-table-item-row-th refunded"
            >Refunded</div>
            <div
              v-if="viewPort == 'large'" 
              class="sm-mobile-table-item-row-th status"
            >Status</div>
            <div class="sm-mobile-table-item-row-th action"></div>
          </div>
        </div>
        <div
          v-for="item in userBillingList"
          :key="item.id"
          class="sm-mobile-table-item"
          :class="{
            'open': item.isOpen
          }"
        >
          <div 
            class="sm-mobile-table-item-row"
            @click="toggleItem(item)"
          >
            <div 
              v-if="viewPort != 'large'"
              class="sm-mobile-table-item-row-elem control-arrow"
            >
              <include-svg :name="'icon-arrow-b-big'" />
            </div>
            <div class="sm-mobile-table-item-row-elem description">
              <text-truncate :text="item.description" />
            </div>
            <div
              v-if="viewPort == 'large'" 
              class="sm-mobile-table-item-row-elem date"
            >{{item.created_at | moment('MMM D, YYYY')}}</div>
            <div
              v-if="viewPort == 'large'" 
              class="sm-mobile-table-item-row-elem amount"
            >{{formatPrice(item.amount)}}</div>
            <div
              v-if="viewPort == 'large'" 
              class="sm-mobile-table-item-row-elem refunded"
            >{{item.refunded ? '-' : ''}}{{formatPrice(item.refunded)}}</div>
            <div 
              v-if="viewPort == 'large'" 
              class="sm-mobile-table-item-row-elem status sm-txt-capitalize"
            >
              <div
                :class="{
                  'paid': item.status == 'Paid',
                  'refunded': item.status == 'Refunded' || item.status == 'Pending',
                  'partially-refunded': item.status == 'Partially Refunded',
                  'unpaid': item.status == 'Unpaid' || item.status == 'Denied',
                  'failed': item.status == 'Failed' || item.status == 'Canceled',
                }"
              >
                <include-svg
                  v-if="item.status == 'Refunded'"
                  :name="'icon-charges-refunded'"
                />
                <include-svg
                  v-if="item.status == 'Partially Refunded'"
                  :name="'icon-charges-partially-refunded'"
                />
                <span
                  class="three-d-chip"
                  v-if="item.hosted_invoice_url && item.status === 'Denied'"
                  @click.prevent="openLink({
                    url: item.hosted_invoice_url,
                    w: 550, 
                    h: 800 
                  })"
                >
                  <span class="sm-txt-strong">{{item.status}} </span>&nbsp;
                  <span style="background-color: white;">&nbsp;</span>&nbsp;
                  <span class="sm-txt-small">Try again (3DS form) &nbsp;<include-svg :name="'icon-arrow-r-2'" /></span>
                </span>
                <span v-else>{{item.status}} </span> 
              </div> 
            </div>
            <div 
              class="sm-mobile-table-item-row-elem action sm-txt-right"
              @click.stop
            >
              <a 
                v-if="item.invoice_pdf_url && item.status != 'Unpaid'"
                :href="`${domain}${item.invoice_pdf_url.replace('/v1/', '')}`" 
                class="icon"
                target="_blank"
              >
                <include-svg :name="'icon-download'" />
              </a>
            </div>
          </div>
          <template v-if="viewPort != 'large'">
            <ul class="sm-mobile-table-item-dropdown">
              <li>
                <span class="sm-txt-strong">Date</span>
                <span>{{item.created_at | moment('MMMM D, YYYY')}}</span>
              </li>
              <li>
                <span class="sm-txt-strong">Amount</span>
                <span>{{formatPrice(item.amount)}}</span>
              </li>
              <li>
                <span class="sm-txt-strong">Refunded</span>
                <span>{{item.refunded ? '-' : ''}}{{formatPrice(item.refunded)}}</span>
              </li>
              <li>
                <span class="sm-txt-strong">Status</span>
                <span
                  :class="{
                    'paid': item.status == 'Paid',
                    'refunded': item.status == 'Refunded' || item.status == 'Pending',
                    'partially-refunded': item.status == 'Partially Refunded',
                    'unpaid': item.status == 'Unpaid' || item.status == 'Denied',
                    'failed': item.status == 'Failed'
                  }"
                >
                  <include-svg
                    v-if="item.status == 'Refunded'"
                    :name="'icon-charges-refunded'"
                  />
                  <include-svg
                    v-if="item.status == 'Partially Refunded'"
                    :name="'icon-charges-partially-refunded'"
                  />
                  <span
                    class="three-d-chip"
                    v-if="item.hosted_invoice_url && item.status === 'Denied'"
                    @click.prevent="openLink({
                      url: item.hosted_invoice_url,
                      w: 550, 
                      h: 800 
                    })"
                  >
                    <span class="sm-txt-strong">{{item.status}} </span>&nbsp;
                    <span style="background-color: white;">&nbsp;</span>&nbsp;
                    <span class="sm-txt-small">Try again (3DS form) &nbsp;<include-svg :name="'icon-arrow-r-2'" /></span>
                  </span>
                  <span v-else>{{item.status}} </span> 
                </span>
              </li>
            </ul>
          </template>
        </div>
      </div>
    </div>
    <btn-block 
      v-if="canShowMore"
      :type="'show'" 
      :text="'Show more'" 
      :icon="'icon-arrow-round'"
      @click="requestMore"
    />

    <sm-spinner :show="showSpinner" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FormatPrice} from '@/utils/general-data';
// import Months from '@/settings/month';
import Spinner from '@/components/Spinner';
import Multiselect from 'vue-multiselect';
import Urls from '@/settings/urls';
import ViewPort from '@/mixins/ViewPort';
import {OpenLinkInPopup} from '@/utils/url';

export default {
  name: 'billing-charges',
  components: {
    'sm-spinner': Spinner,
    'dropdown-block': Multiselect,
  },
  data() {
    return {
      domain: Urls.domain,
      showSpinner: false,
      userBillingList: [],

      //TEMP data
      // monthNames: Months.en,
      // month: 'May',

      allowedBreakpoints: [
        'small',
        'medium',
        'large'
      ],
      canShowMore: false,
      // morePages: 0
    };
  },
  created() {
    this.getCharges();
  },
  computed: {
    ...mapGetters({
      provider: 'provider',
      isMobile: 'isMobile',
    })
  },
  mixins: [ViewPort],
  methods: {
    ...mapActions({
      getUserCharges: 'account/getUserCharges',
      showGlobalNotification: 'showGlobalNotification',
    }),
    formatPrice: FormatPrice,
    getCharges(params) {
      if (!params)
        params = {};

      this.showSpinner = true;
      this.getUserCharges(params)
        .then((list) => {
          if (list && list.charges && list.charges.length) {
            // this.canShowMore = list.has_more_charges;
            //TEMP
            this.canShowMore = false;

            this.userBillingList = [...this.userBillingList, ...this.prepareBillingList(list.charges)];
          } else {
            this.canShowMore = false;
          }

          this.showSpinner = false;
        })
        .catch(e => {
          if (this.provider.payment_gateway == 'stripe' && e.response.data && e.response.data.errors && e.response.data.errors.base) {
            this.showGlobalNotification({
              type: 'error',
              value: e.response.data.errors.base
            });
          }

          this.showSpinner = false;
        });
    },
    prepareBillingList(charges) {
      return charges.filter(item => item != null)
        .map(item => {
          const temp = {...item};
          temp.isOpen = false;

          return temp;
        });
    },
    toggleItem(item) {
      if (this.viewPort != 'large')
        item.isOpen = !item.isOpen;
    },
    requestMore() {
      // this.morePages++;
      this.getCharges({
        // page: this.morePages + 1
        starting_after: this.userBillingList[this.userBillingList.length - 1].id
      });
    },
    openLink: OpenLinkInPopup
  }
}
</script>